
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'

export default class InstallationStep extends React.Component {
  render() {
    const {title, number, children} = this.props
    return (
      <div className='step_container'>
        <div className='wizard_step_number'>{number}</div>
        <div className='breakLine' />
        <div className='text'>{title}</div>
        {!!children && <div className='detail'>{children}</div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/InstallationStep/index.js